import { Component, Input } from '@angular/core';

import { VBrickPlayerComponent } from 'vbrick-player-src/VbrickPlayer.Component';

import { VideogularComponent } from '../Videogular.Component';
import { VgStates } from '../VgStates';

import styles from './VgPlayPauseButton.module.less';

/**
 * Adds a button inside vg-controls to play and pause media.
 *
 * <pre>
 * <videogular>
 *    <vg-media></vg-media>
 *
 *    <vg-controls>
 *        <vg-play-pause-button></vg-play-pause-button>
 *    </vg-controls>
 * </videogular>
 * </pre>
 *
 */
@Component({
	selector: 'vg-play-pause-button',
	host: {
		'[class]': 'styles.root'
	},
	template: `
		<button
			[attr.aria-label]="isPlaying ? vbrickPlayer.translations.pause : vbrickPlayer.translations.play"
			type="button"
			[ngClass]="[
				styles.button,
				isPlaying ? styles.pause : styles.playRounded
			]"
			[tooltip]="playPauseTooltip"
			placement="auto"
			vbControlBarFocus
			(click)="vgApi.playPause()">
		</button>
		<ng-template #playPauseTooltip>
			{{ isPlaying ? vbrickPlayer.translations.pause : vbrickPlayer.translations.play }}
		</ng-template>
		`
})
export class VgPlayPauseButtonComponent {
	public readonly styles = styles;
	constructor(
		public vbrickPlayer: VBrickPlayerComponent,
		public vgApi: VideogularComponent
	) {}

	public get isPlaying(): boolean {
		return this.vgApi.currentState === VgStates.PLAY;
	}
}
